import {setDataInLocalStorage} from "../../../../../utils";
import React, {useState} from "react";
import combinedSettingItems from "../../CombineSettings";
import {userUpdateAvatar} from "../../../../../redux/actions/user/actions";
import {useDispatch, useSelector} from "react-redux";
import SafeDynamicComponent from "../../../SafeDynamicComponent.jsx";

function SettingItem(props) {
    const {name, data} = props;
    const TargetItem = combinedSettingItems[name];
    const dispatch = useDispatch();
    const avatarIndex = useSelector(state => state.user.avatar)
    const getActiveIndex = () => {
        if (name === 'avatar') {
            return parseFloat(avatarIndex)
        }
        return parseInt(localStorage.getItem(name)) || 1
    }

    const [activeIndex, setActiveIndex] = useState(getActiveIndex());


    const handleItemClick = (index, itemName) => {
        if (activeIndex === index && name !== 'avatar') return;
        if (name === 'avatar') {
            dispatch(userUpdateAvatar({avatar: index}))
        } else {
            const element = document.querySelector(".belote-wrapper");
            const regexPattern = new RegExp(`${itemName}-V\\d+`);

            element.classList.forEach(cls => {
                if (regexPattern.test(cls)) {
                    element.classList.remove(cls);
                    element.classList.add(`${itemName}-V${index}`);
                }
            });
            setActiveIndex(index)
            setDataInLocalStorage(itemName, index);
        }
    }

    return (
        <ul className="settings__elements--wrapper">
            {data?.map((item, index) => {
                return (
                    <SafeDynamicComponent
                        Component={TargetItem}
                        key={index}
                        item={item}
                        name={name}
                        isActive={index + 1 === getActiveIndex()}
                        onItemClick={() => handleItemClick(index + 1, name)}
                    />
                )
            })}
        </ul>
    )
}

export default SettingItem